"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPromiseResolverHook = void 0;
const react_1 = require("react");
const createPromiseResolverHook = () => {
    const cache = new WeakMap();
    return (promise) => {
        const [, setCount] = (0, react_1.useState)(0);
        if (!promise) {
            return undefined;
        }
        const result = cache.get(promise);
        if (result) {
            return result;
        }
        else {
            promise.then((value) => {
                cache.set(promise, { value });
                setCount((count) => count + 1);
            });
        }
    };
};
exports.createPromiseResolverHook = createPromiseResolverHook;
